import React, {forwardRef} from 'react'

import {Button} from '@vio/atlas/Button'
import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {Alert} from '@vio/atlas/src/components/designSystem/Alert'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {Text} from '@vio/atlas/Text'

import type {HopperAdCreative} from './types'

interface Props {
  creative: HopperAdCreative
  onCTAClick?: () => void
}

const LOGO_WIDTH = {
  mobile: 48,
  desktop: 56
}

export const HopperInlineBannerContent = forwardRef<HTMLDivElement, Props>(
  ({creative, onCTAClick}, ref) => {
    const {isMobile} = useDeviceLayout()

    return (
      <div ref={ref}>
        <Alert>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            desktopXs={{flexDirection: 'row'}}
            gap="s300"
          >
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap="s400"
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src={creative.logoUrl}
                alt={creative.titleText}
                width={LOGO_WIDTH[isMobile ? 'mobile' : 'desktop']}
              />
              <Box display="flex" flexDirection="column" gap="s100">
                <Text variant={isMobile ? 'labelS' : 'labelM'}>
                  {creative.titleText}
                </Text>
                <Text variant="bodyS">{creative.bodyText}</Text>
              </Box>
            </Box>
            <Box
              display="flex"
              justifyContent="center"
              width="100%"
              desktopXs={{width: 'auto'}}
            >
              <Button
                variant="tertiary"
                size="lg"
                onClick={onCTAClick}
                iconStart={<Icon name="Unlock" />}
                fullWidth={isMobile}
              >
                {creative.ctaText}
              </Button>
            </Box>
          </Box>
        </Alert>
      </div>
    )
  }
)

HopperInlineBannerContent.displayName = 'HopperInlineBannerContent'
